import { useDrawer } from '../inc-drawer/inc-drawer.hooks';
import { CustomerEditTagsDrawerDataType } from './customer-edit-tags-drawer.component';

export const useCustomerTagsDrawer = () =>
  useDrawer<CustomerEditTagsDrawerDataType>();
